/*# sourceMappingURL=allergies.component-M5Q3K3QY.css.map */
